import React, { useState } from "react";
import { ModalNotification } from "@common/LifeAtModal/LifeAtModal";
import { RoomControls } from "../RoomController";
import { RoomModal } from "./RoomModalCommonElements";
import { RoomSettingsForm } from "./RoomSettingsForm";

const MODAL_TITLE = "Room Settings";

interface RoomSettingsModalProps {
    readonly roomId: string;
    readonly roomControls: RoomControls;
    readonly isOpen: boolean;
    readonly handleClose: () => void;
}

function RoomSettingsModal(props: RoomSettingsModalProps) {
    const [modalNotifications, setModalNotifications] = useState<ModalNotification[]>([]);

    function handleNotification(notification: ModalNotification) {
        setModalNotifications((original) => [...original, notification]);
        clearNotificationsAfterDelay();
    }

    function clearNotificationsAfterDelay(ms?: number) {
        setTimeout(() => setModalNotifications([]), ms ?? 3000);
    }

    return (
        <RoomModal
            key={`room-settings-modal`}
            title={MODAL_TITLE}
            isOpen={props.isOpen}
            closeModal={props.handleClose}
            notifications={modalNotifications}
        >
            {props.roomControls?.roomInfo && (
                <RoomSettingsForm
                    roomId={props.roomId}
                    roomSettings={props.roomControls.roomInfo}
                    setRoomSettings={props.roomControls.setRoomInfo}
                    // Only allow updating the Room name when the video call is not running, because the Twilio
                    // video call token has already been generated when a call is in progress.
                    isEditable={!props.roomControls.isVideoChatInit}
                    onError={handleNotification}
                />
            )}
        </RoomModal>
    );
}

export default RoomSettingsModal;
